module.exports = __webpack_public_path__ + "img/es3.af62fc88.png";